<script lang="ts">
  import { FormLabel } from '$lib/components/form';

  /** Default: `undefined` */
  export let description = undefined;
  /** Default: `false` */
  export let disabled = false;
  /** Default: `undefined` */
  export let label = undefined;
  /** Default: `false` */
  export let loading = false;
  /** Default: `''` */
  export let value = '';
  /** Default: `''` */
  export let width = '';
</script>

<FormLabel bind:label bind:description bind:width>
  {#if loading}
    <!-- Placeholder -->
    <select class="select" disabled>
      <option value="1">...</option>
    </select>
  {:else}
    <!-- Select -->
    <select class="select" {disabled} bind:value on:change>
      <slot />
    </select>
  {/if}
</FormLabel>
